import * as React from 'react';

export const ForgotUsernamePage = React.lazy(() =>
  import('./ForgotUsernamePage')
);
